// extracted by mini-css-extract-plugin
export default {"full_screen":"Spinners_full_screen__dGYh3","spinner_block":"Spinners_spinner_block__MHNx-","spinner":"Spinners_spinner__YMTg6","message":"Spinners_message__i7Er4"};